
import Glide, { Autoplay, Controls } from '@glidejs/glide/dist/glide.modular.esm'
import "@glidejs/glide/dist/css/glide.core.min.css";

let itemCount =  document.getElementsByClassName('glide__slide').length;
let start = Math.floor(Math.random() * Math.floor(itemCount));

if(itemCount) {
  new Glide('.glide',{
    type: 'carousel',
    autoplay:4000,
    animationDuration: 0,
    gap:0,
    startAt: start

  }).mount({ Autoplay, Controls })
}



